import { Component, OnInit, ViewChild, Inject, Input } from '@angular/core';
import { NgForm, UntypedFormControl, NgControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from './../../services/global.service';
import { HttpService } from './../../services/http.service';
import { PipelineService } from './../../services/pipeline-service';

@Component({
  selector: 'app-monitor',
  templateUrl: './monitor.component.html',
  styleUrls: ['./monitor.component.css']
})
export class MonitorComponent implements OnInit {

  @Input() max: Date | null
  today = new Date();

  StartTime;
  EndTime;
  runBy: string;
  monitorPipelineList;
  firstTableClass: string = "hideData";
  displayedColumns = ['pipelineName', 'runStart', 'duration', 'status', 'parameters'];
  @ViewChild('monitorPipelineTableSort', { static: true }) public monitorPipelineTableSort: MatSort;
  @ViewChild('monitorPipelinePaginator', { static: false }) monitorPipelinePaginator: MatPaginator;

  pipelineNameFilter = new UntypedFormControl('');
  statusFilter = new UntypedFormControl('');
  filterValues = {
    pipelineName: '',
    status: ''
  };

  constructor(
    public globals: GlobalService,
    public httpService: HttpService,
    public pipelineService: PipelineService,
    public router: Router,
    public _router: ActivatedRoute,
    public dialog: MatDialog) { }

  ngOnInit() {

    this.pipelineNameFilter.valueChanges
      .subscribe(
        pipelineName => {
          this.filterValues.pipelineName = pipelineName;
          this.monitorPipelineList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.statusFilter.valueChanges
      .subscribe(
        status => {
          this.filterValues.status = status;
          this.monitorPipelineList.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.pipelineName.toLowerCase().indexOf(searchTerms.pipelineName.toLowerCase()) !== -1
        && data.status.toLowerCase().indexOf(searchTerms.status.toLowerCase()) !== -1;
    }
    return filterFunction;
  }

  getMonitorPipelineList(monitorPipelineForm: NgForm) {
    this.runBy = this.globals.loggedInUser;
    this.StartTime = monitorPipelineForm.value.StartTime;
    this.EndTime = monitorPipelineForm.value.EndTime;

    let values = {
      "StartTime": this.StartTime,
      "EndTime": this.EndTime,
      "ContinuationToken": this.pipelineService.ContinuationToken,
      "PipelineNames": []
    }

    this.continueMonitorPipelineList(values);
  }

  continueMonitorPipelineList(values) {
    this.pipelineService.fetchPipelineList(values).subscribe((monitorPipelineData: any): void => {
      this.pipelineService.ContinuationToken = monitorPipelineData.continuationToken;
      this.monitorPipelineList = new MatTableDataSource(monitorPipelineData.value);
      this.monitorPipelineList.filterPredicate = this.createFilter();
      this.monitorPipelineList.sort = this.monitorPipelineTableSort;
      this.monitorPipelineList.paginator = this.monitorPipelinePaginator;
      this.firstTableClass = "showData";
    });
  }

 

  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight // viewport: ~500px
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;

    if (scrollLocation > limit) {
      let values = {
        "StartTime": this.StartTime,
        "EndTime": this.EndTime,
        "ContinuationToken": this.pipelineService.ContinuationToken,
        "PipelineNames": []
      }
      this.continueMonitorPipelineList(values);
    }
  }

  deserialize(json): any[] {
    let collection: any[] = [];
    collection.push(json);
    return collection;
  }

  viewParameterDilog(parameter): void {
    this.globals.openModelWindow(null, null, MonitorParameterModalComponent, '790px', 'confirm-modalbox-dark', this.deserialize(parameter));
  }
}


@Component({
  selector: 'monitor-parameter-modal-component',
  templateUrl: './monitor-parameter-modal.component.html',
  styleUrls: ['./monitor-parameter-modal.component.css']
})

export class MonitorParameterModalComponent {

  editDisabled: boolean = true;
  Heading: string = "Parameters";


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MonitorParameterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public httpService: HttpService,
    public globals: GlobalService,
    public router: Router,
    public _router: ActivatedRoute
  ) { };

  

  onCancelClick(): void {
    this.dialogRef.close("Cancel");
  }

}
